import dayjs from "dayjs"
import { localisedValue } from "utils"

export const editHistoryTransformHelper = response => {
  const { data: editHistoryData, totalCount: count } = response
  const editHistoryRows = editHistoryData.map(e => {
    let convertedTime = dayjs.utc(e?.createdAt).local()
    return {
      ...e,
      key: e?.id,
      date: convertedTime,
      ...(e?.LoggedBy && {
        editedBy: {
          id: e?.LoggedBy?.id,
          name: localisedValue({ object: e?.LoggedBy, key: "name" }),
          designation: localisedValue({ object: e?.LoggedBy?.UserDesignation, key: "short" }),
          city: localisedValue({ object: e?.LoggedBy?.City, key: "name" }),
        },
      }),

      isClientModified: e?.ClientAction?.key==="client_details_modified",
      log: localisedValue({object: e?.ClientAction, key: "title"}),
    }
  })
  return { data: editHistoryRows, count: count }
}
